
import { useIntersectionObserver } from '@vueuse/core'
import Vue from "vue";

export const lazyPlugin = {
    install(app) {

     
        Vue.directive('text-lazy', {
            inserted(el, binding) {
                
                const { stop } = useIntersectionObserver(
                    el,   
                    ([{ isIntersecting }]) => {
                        if (isIntersecting) {
                            el.textContent = binding.value;
                            stop();
                        }
                    },
                )
            }
        })
    }
}